import { jsx as m } from "react/jsx-runtime";
import { Overlay as t } from "@radix-ui/react-dialog";
import o from "./index.es5610.js";
import s from "classnames";
const p = ({ children: r, fullSize: e }) => /* @__PURE__ */ m(t, { className: s(o.overlay, { [o.fullSize]: e }), children: r });
export {
  p as BaseModalContent
};
//# sourceMappingURL=index.es769.js.map
